// eslint-disable-next-line no-use-before-define
import React from 'react';
import { DownloadItem } from '../download-item';
import useDownloadService from '../hook/use-download-service';
const DownloadList = ({ files }) => {
    const { retryDownload, getDownloadLink, cancelDownload } = useDownloadService();
    return (React.createElement(React.Fragment, null, files.map((file) => (React.createElement(DownloadItem, { key: file.id, ...file, retry: (id) => retryDownload(id), getLink: (id) => getDownloadLink(id), cancel: (id) => cancelDownload(id) })))));
};
export { DownloadList };
//# sourceMappingURL=index.js.map